import {isFeatureEnabled} from '../Services/OptimizelyService/OptimizelyService';
import {updateRecaptchaOptimizelyData} from '../redux/app-state-slice';
import {SPECIAL_EVENT_PAGE_NAME} from '../utils/constants/constants';

export function checkRecaptchaChooser(customerData) {
  return !customerData?.isDealerHostApplication?.value && customerData.prequalSource.value !== 'qr-WC';
}

export async function recaptchaChooser(pathname, appConfig, customerData, dispatch) {
  const recaptchaVariation = appConfig.recaptchaVariation;
  const recaptchaChooserFlag = {isEnabled: false, variationKey: 'off'};
  if (!pathname.toLowerCase().includes(SPECIAL_EVENT_PAGE_NAME.toLowerCase()) && checkRecaptchaChooser(customerData)) {
    const {variationKey} = await isFeatureEnabled(recaptchaVariation, appConfig, customerData);
    recaptchaChooserFlag.isEnabled = variationKey === 'control' || variationKey === 'treatment';
    recaptchaChooserFlag.variationKey = variationKey;
    dispatch(updateRecaptchaOptimizelyData(recaptchaChooserFlag));
  }
  return recaptchaChooserFlag;
}
